import React, { useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Outlet, useLocation } from 'react-router-dom';
import { debounce } from 'lodash';
import { connect } from 'react-redux';
import { generateRoleMenu, recordSize } from '@/slices/layoutSlice';
import { getUserInfoAsync, getLicenseExpiredSoonPromptAsync } from '@/slices/authSlice';
import Header from '../Header';
import LicenseAlert from '../LicenseAlert';
import LicenseTip from '../LicenseTip';
import TrialFeedback from '../TrialFeedback';
import GlobalHeaderWarn from '../GlobalHeaderWarn';

function BasicLayout({
  recordSize,
  getUserInfoAsync,
  perms,
  generateRoleMenu,
  getLicenseExpiredSoonPromptAsync,
}) {
  const { pathname } = useLocation();

  useEffect(() => {
    const resize = debounce(() => {
      recordSize({
        clientWidth: document.body.clientWidth,
        clientHeight: document.body.clientHeight,
      });
    }, 200);
    resize();
    getLicenseExpiredSoonPromptAsync();
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, [recordSize, getLicenseExpiredSoonPromptAsync]);

  useEffect(() => {
    if (pathname !== '/') {
      getUserInfoAsync();
    }
  }, [pathname, getUserInfoAsync]);

  useEffect(() => {
    generateRoleMenu({
      perms,
    });
  }, [generateRoleMenu, perms]);

  return (
    <Root id='basic-layout'>
      <GlobalStyle />
      <Header />
      <LicenseTip />
      <GlobalHeaderWarn />
      <Hr />
      <Body className='narrow-scrollbar'>
        <Outlet />
      </Body>
      <LicenseAlert />
      <TrialFeedback />
    </Root>
  );
}

export default connect(
  (state) => ({
    perms: state.auth.perms,
    menus: state.layout.menus,
  }),
  {
    recordSize,
    getUserInfoAsync,
    generateRoleMenu,
    getLicenseExpiredSoonPromptAsync,
  },
)(BasicLayout);

const GlobalStyle = createGlobalStyle`
  html, body {
    background-color: #F7F8FA;
  }
`;

const Root = styled.div`
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Body = styled.div`
  flex: 1;
  overflow: auto;
`;

const Hr = styled.div`
  height: 2px;
  background-color: #edeff2;
`;
